import { render, staticRenderFns } from "./NotificationFeedItemBody.vue?vue&type=template&id=1024db02&scoped=true"
import script from "./NotificationFeedItemBody.vue?vue&type=script&lang=js"
export * from "./NotificationFeedItemBody.vue?vue&type=script&lang=js"
import style0 from "./NotificationFeedItemBody.vue?vue&type=style&index=0&id=1024db02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024db02",
  null
  
)

export default component.exports